import { t } from "i18next";
import toast from "react-hot-toast";
import { Loader, Modal } from "ui";

import {
  useCreateProductSet,
  useProductSetDetails,
  useUpdateProductSet
} from "../../../apis";
import {
  convertProductSetFormDataToCreateRequestBody,
  getInitialProductSetValues
} from "../../../helpers";
import { ProductSetFormValues } from "../../../productsSets.types";
import { ProductSetForm } from "../../forms";
import { ProductSetModalProps } from "./ProductSetFormModal.types";

const PRODUCT_SET_FORM_ID = "feed-insert-form-id";

const ProductSetFormModal = ({
  isOpen,
  onClose,
  editableProductSetId
}: ProductSetModalProps) => {
  const { productSetDetails, isProductSetDetailsLoading } =
    useProductSetDetails(editableProductSetId);

  const updateProductSet = useUpdateProductSet({
    onSuccess: () => {
      onClose();
      toast.success(t("Product set has been updated successfully"));
    }
  });

  const createProductSet = useCreateProductSet({
    onSuccess: onClose
  });

  const handleFormSubmit = (formData: ProductSetFormValues) => {
    const body = convertProductSetFormDataToCreateRequestBody(formData);

    if (formData.id) {
      updateProductSet.mutate({ id: formData.id, ...body });
    } else {
      createProductSet.mutate(body);
    }
  };

  return (
    <Modal
      formId={PRODUCT_SET_FORM_ID}
      isOpen={isOpen}
      title={`${editableProductSetId ? "Edit" : "Create"} Product Set`}
      isLoading={createProductSet.isLoading || updateProductSet.isLoading}
      okText={editableProductSetId ? "Save" : "Create"}
      onClose={onClose}
    >
      {editableProductSetId && isProductSetDetailsLoading && <Loader />}

      {(!editableProductSetId || productSetDetails) && (
        <ProductSetForm
          formId={PRODUCT_SET_FORM_ID}
          onSubmit={handleFormSubmit}
          defaultValues={getInitialProductSetValues(productSetDetails)}
        />
      )}
    </Modal>
  );
};

export default ProductSetFormModal;
